import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import heroImage from '../../assets/images/maturityservice/heroimage.png';
import benefitImage from '../../assets/images/maturityservice/benefit.png';
import wenduImage from '../../assets/images/maturityservice/wendu.png';
import optimizationImage from '../../assets/images/maturityservice/optimization.png';
import './maturityservice.scss';
import AccordionCard from './card/AccordionCard';
import SEO from '../../components/SEO';

export default function AWSMaturityService() {
    const businessSolutions = [
        {
            id: 1,
            title: 'Billing Discounts',
            desc: 'Unlock annual billing discounts of up to 30%, boosting operational cost savings and ROI.',
        },
        {
            id: 2,
            title: 'Option to Process AWS Bill in your local currency',
            desc: 'Effortlessly process your AWS bill in local currency for simplified financial transactions.',
        },
        {
            id: 3,
            title: 'Simplified Financial Insights',
            desc: 'Enjoy seamless monthly invoicing, custom bill splitting, and efficient chargeback processing for enhanced transparency.',
        },
        {
            id: 4,
            title: 'Well Architected Reviews',
            desc: 'Ensure the integrity of your cloud infrastructure with regular Well Architected Reviews, enhancing security, performance, and efficiency, with the possibility of getting $5,000 worth of AWS credits per workload reviewed and remediated.',
        },
        {
            id: 5,
            title: 'Access to AWS Partner Funding Programs',
            desc: 'Leverage exclusive AWS Partner funding programs to fast-track your cloud initiatives and drive innovation.',
        },
        {
            id: 6,
            title: 'Solution Design Advisory',
            desc: 'Receive personalized advisory for solution designing, aligning your cloud architecture with your business objectives.',
        },
        {
            id: 7,
            title: 'Designated Technical Account Manager',
            desc: 'Access a dedicated Technical Account Manager for personalized support and guidance.',
        },
        {
            id: 8,
            title: 'Annual Cloud Architecture Reviews',
            desc: 'Benefit from comprehensive annual reviews of your cloud architecture to identify optimization opportunities and adhere to best practices.',
        },
    ];

    return (
        <React.Fragment>
            <SEO
                title="AWS Maturity Assessment with CloudPlexo's Expert Solutions"
                description="Elevate your AWS maturity in with CloudPlexo's expert services. Enhance performance, security, and scalability on the AWS platform. Explore our solutions now."
                keywords="aws cloud maturity assessment"
            />

            <section
                className="w-100 maturityservice"
                style={{ paddingTop: '110px' }}
            >
                <Container>
                    <Row className="align-items-center justify-content-center text-center">
                        <Col
                            md={10}
                            lg={9}
                            className="  mt-sm-0 pt-sm-0 col-12"
                        >
                            <div>
                                <p className="hero-headings mb-3">
                                    CloudPlexo AWS Maturity Service
                                    <br />
                                </p>
                                <p
                                    style={{ lineHeight: '24.2px' }}
                                    className="para-desc mb-2"
                                >
                                    A transformative solution designed to propel
                                    your cloud operations towards enhanced
                                    efficiency, optimal performance, and
                                    strategic growth. With a steadfast focus on
                                    continuous cloud cost optimization, this
                                    service is tailored to meet the evolving
                                    needs of modern businesses.
                                </p>

                                <div className="mt-4 pt-2 mx-auto d-flex  justify-content-center gap-3 align-items-center">
                                    <a
                                        href="#maturity-services"
                                        className="btn btn-mobile-i "
                                        style={{
                                            backgroundColor: '#3E54AC',
                                            color: '#fff',
                                        }}
                                    >
                                        Learn More
                                    </a>
                                </div>
                            </div>
                        </Col>
                        <Col
                            md={12}
                            lg={12}
                        >
                            <img
                                src={heroImage}
                                alt="AWS Maturity Assessment with CloudPlexo's Expert Solutions"
                                className="d-block img-fluid mx-auto mt-5"
                            />
                        </Col>
                    </Row>
                </Container>
                <div
                    className="core-benefits"
                    id="maturity-services"
                >
                    <Container>
                        <div className="row align-items-center ">
                            <div className="col-md-6">
                                <img
                                    src={benefitImage}
                                    alt="The Core Benefit"
                                    className="img-fluid d-block mx-auto"
                                />
                            </div>
                            <div className="col-12 col-md-6">
                                <div>
                                    <h4 className="section-headings mb-3">
                                        The Core Benefit
                                    </h4>
                                    <p
                                        className="section-text"
                                        style={{ lineHeight: '24.2px' }}
                                    >
                                        At the heart of our Cloud Maturity
                                        Service lies the commitment to
                                        continuous cloud cost optimization.
                                        <br />
                                        We understand the dynamic nature of
                                        cloud expenses and the importance of
                                        adapting to changing business
                                        requirements. With our expertise,
                                        advanced tools, and industry insights,
                                        we ensure that your cloud expenses
                                        remain aligned with your organisational
                                        goals at all times.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Container>
                </div>
                <div className="business-problems">
                    <Container>
                        <h3 className="section-headings mb-5 text-center">
                            Solving Business Problems
                        </h3>

                        <div className="row align-items-center service-row">
                            <div className="col-md-6">
                                <img
                                    src={wenduImage}
                                    alt="Solving Business Problems"
                                    className="img-fluid d-block mx-auto"
                                />
                            </div>
                            <div className="col-12 col-md-6">
                                <div>
                                    <h4
                                        style={{
                                            fontWeight: '700',
                                        }}
                                        className="title mb-3"
                                    >
                                        Wendu - Security and Cost Management
                                        Platform (Powered by AI)
                                    </h4>
                                    <p
                                        style={{ lineHeight: '24.2px' }}
                                        className=" mb-2"
                                    >
                                        Harness the power of Wendu's AI-driven
                                        insights to monitor security, cost, and
                                        optimization metrics in real time.
                                    </p>

                                    <div className="mt-4 ">
                                        <a
                                            href="https://wendu.io"
                                            className="btn btn-outline-primary btn-mobile-i"
                                        >
                                            Learn More
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row align-items-center service-row">
                            <div className="col-md-6">
                                <img
                                    src={optimizationImage}
                                    alt="Monthly Cost Optimization Strategy
                                        Sessions"
                                    className="img-fluid d-block mx-auto"
                                />
                            </div>
                            <div className="col-12 col-md-6">
                                <div>
                                    <h4
                                        style={{
                                            fontWeight: '700',
                                        }}
                                        className="title mb-3"
                                    >
                                        Monthly Cost Optimization Strategy
                                        Sessions
                                    </h4>
                                    <p
                                        style={{ lineHeight: '24.2px' }}
                                        className=" mb-2"
                                    >
                                        Collaborate with both CloudPlexo & AWS
                                        experts to develop tailored cost
                                        optimization strategies, ensuring
                                        maximum value from your cloud
                                        investments.
                                    </p>

                                    <div className="mt-4 ">
                                        <a
                                            href="/contact-us"
                                            className="btn btn-outline-primary btn-mobile-i"
                                        >
                                            Contact Sales
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Other Solutions */}
                        <div className="row service-solutions">
                            {businessSolutions.map((solution) => (
                                <div
                                    className="col-md-6"
                                    key={solution.id}
                                >
                                    <div className="service-row-2">
                                        <h4 className="mb-3">
                                            {solution.title}
                                        </h4>
                                        <p>{solution.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Container>
                </div>
                <div className="faq">
                    <Container>
                        <h3 className="section-headings mb-3">
                            Frequently Asked Questions
                        </h3>
                        <div className="row">
                            <AccordionCard />
                        </div>
                    </Container>
                </div>
                {/* CTA */}
                <div className="cta">
                    <Container>
                        <div className="row justify-content-center">
                            <div className="col-10">
                                <p>
                                    With CloudPlexo’s AWS Maturity Service, you
                                    embark on a journey of continuous
                                    improvement, cost optimization, and
                                    strategic alignment. Our commitment is to
                                    enable your organization to navigate the
                                    complexities of the cloud landscape while
                                    achieving substantial financial benefits.
                                </p>
                                <div className="mt-4 pt-2 mx-auto d-flex flex-sm-row flex-column justify-content-center gap-3 align-items-center">
                                    <a
                                        href="https://docs.aws.amazon.com/awsaccountbilling/latest/aboutv2/consolidated-billing.html"
                                        className="btn btn-mobile-i "
                                        style={{
                                            backgroundColor: '#3E54AC',
                                            color: '#fff',
                                        }}
                                    >
                                        Learn more about AWS consolidated
                                        billing
                                    </a>

                                    <a
                                        href="/contact-us"
                                        className="btn btn-outline-primary btn-mobile-i"
                                    >
                                        Contact Us
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Container>
                </div>
            </section>
        </React.Fragment>
    );
}
